export default __webpack_public_path__ + "static/media/work.0b1605e1.svg";